import { render, staticRenderFns } from "./RestartBtn.vue?vue&type=template&id=64c58f6a&"
import script from "./RestartBtn.vue?vue&type=script&lang=js&"
export * from "./RestartBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports